(function () {
    'use strict';

    angular
        .module("skillsApp")
        .controller("MaintenanceController", MaintenanceController);

    function MaintenanceController(config, $state) {
        var vm = this;

        vm.maintenance = config.settings.maintenance;
        
        // todo: use dataService.getSettings to get fresh copy of settings?

        if (!vm.maintenance || vm.maintenance.status === 'off') {
            return $state.go('app-main.employee');
        }
        if (vm.maintenance.status === 'adminOnly' && config.settings.user.isAdmin) {
            return $state.go('app-main.employee');
        }
    }

})();